import { injectTranslate } from '@recruitee/i18n';
import { tagsCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const tagsColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Tags,
  label: injectTranslate()('app.offers.table.tags'),
  visible: true,
  geometry: {
    width: 200,
    minWidth: 100,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: tagsCellFactory('offerTags', { isHoverable: false, disabled: true }),
}));
